<template>
  <div class="progress_container" style="padding: 20rem 0rem 20rem 0rem">
    <div>
      <!--选择一级题干-->
      <progressHead
        style="padding: 0rem 20rem 20rem 22rem"
        v-if="progressHeadVisible"
        class="progress_head"
        ref="progressHead"
        :labels="labelArr"
      />
    </div>
    <!--答题流程-->
    <div class="progress_body">
      <vue-scroll :ops="ops" @handle-scroll="onScroll">
        <div ref="sortableRef">
          <div
            v-for="(item, index) in progressItems"
            :key="item.id"
            style="position: relative; width: 100%"
            class="fieldsList"
            :class="{ hide: !isPractise && item.display == 'showAnser' }"
          >
            <progressItem
              :class="{
                progress_item: true,
                progress_item_selected: progressItemIdx === index,
              }"
              :progressItem.sync="progressItems[index]"
              :nowLabel="nowLabel"
              :nowLabelId="nowLabelId"
              :type="type"
              :processOption="processOption"
              :processId="`${processIndex + 1}-${index + 1}`"
              ref="progressItemRef"
              @click.native="progressItemSelected(index, item.id)"
              @updateTolist="updateTolist"
              :isPractise="isPractise"
              :options="modeOptions"
              :optionNotEmpty.sync="optionNotEmpty"
            />
            <!-- 移动题干 -->
            <div
              class="fields_move"
              :class="{ fields_move_selected: progressItemIdx === index }"
            >
              <img
                class="fieldsMoveImg"
                src="@/assets/images/icon-move.png"
                alt=""
              />
            </div>
            <!-- 移动操作 -->
            <div
              :class="{
                fields_operation: true,
                fields_operation_selected: progressItemIdx === index,
              }"
            >
              <div class="handleFields" @click="handleOperate($event)"></div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>

    <!--流程操作弹框-->
    <div
      class="operateBox"
      :style="{
        top: screenTop + lastScroll.y - scroll.y + 'px',
        left: screenLeft + lastScroll.x - scroll.x + 'px',
      }"
      v-if="isOperate"
      ref="operateBox"
    >
      <OperateFrame
        :fieldsArr.sync="progressItems"
        :id="nowId"
        @operateInsertBlank="operateInsertBlank"
        @operateCopy="operateCopy"
      />
    </div>
  </div>
</template>

<script>
import progressHead from "./parts/firstQuestion.vue";
import progressItem from "./parts/progressItemFour.vue";
import { EventBus } from "@/utils/event-bus.js";
import vueScroll from "vuescroll";
import OperateFrame from "./parts/operateFrame.vue";
import Sortable from "sortablejs";
import { getModeSetting } from "@/api/answeringProcess";
import { getTopListById, saveProgressBatch,saveProgressBatch4 } from "@/api/answeringProcess";
import { getRefiningModeSetting } from "@/api/answeringProcess";
import _ from "lodash";
export default {
  components: {
    progressHead,
    progressItem,
    vueScroll,
    OperateFrame,
  },
  computed: {
    coilingId() {
      return this.$store.state.coilingId;
    },
    fieldsJSON() {
      //解决监听新旧值一样的问题
      return JSON.parse(JSON.stringify(this.$store.state.fieldsJSON));
    },
    processOption() {
      const processOptions = [];
      this.topList.forEach((tv) => {
        const progressItems = _.get(tv, "progressItems", []);
        progressItems.forEach((p) => {
          if (p.bindId) {
            processOptions.push({
              value: p.bindId,
              label: p.bindId,
            });
          }
        });
      });
      return _.uniq(processOptions);
    },
    regionId() {
      return this.$store.state.regionId;
    },
    bookId() {
      return this.$store.state.bookId;
    },
    catalogType() {
      return this.$store.state.catalogType;
    },
    catalogId() {
      return this.$store.state.catalogId;
    },
  },
  mounted() {
    //新建流程
    EventBus.$on("refreshModeSetting", this.refreshModeSetting);
    EventBus.$on("createProgress", this.createProgressItem);
    EventBus.$on("getQuestionNumber", this.getQuestionNumber);
    EventBus.$on("updatePractiseMode", this.UpdatepractiseMode);
    EventBus.$on("deleteProgress", this.operateDelete);
    EventBus.$on("saveProgress", this.saveProgress);
    EventBus.$on("resethData", this.resethData);  //重置数据
    //获取试题模块类型
    EventBus.$on("getType", this.getType);
    EventBus.$on(
      "createProgressFromCollection",
      this.createProgressFromCollection
    );
    EventBus.$on("updateProgressToPage", this.updateProgressToPage);

    // 监听点击空白事件
    document.addEventListener("click", this.monitoringClick.bind(this));
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.initSortable();
    });

    this.refreshModeSetting(false);
  },
  beforeDestroy() {
    EventBus.$off("refreshModeSetting", this.refreshModeSetting);
    EventBus.$off("updatePractiseMode", this.UpdatepractiseMode);
    EventBus.$off("createProgress", this.createProgressItem);
    EventBus.$off("getQuestionNumber", this.getQuestionNumber);
    EventBus.$off("deleteProgress", this.operateDelete);
    EventBus.$off("saveProgress", this.saveProgress);
    EventBus.$off("resethData", this.resethData);
    EventBus.$off(
      "createProgressFromCollection",
      this.createProgressFromCollection
    );
    EventBus.$off("updateProgressToPage", this.updateProgressToPage);
    window.removeEventListener("scroll", this.handleScroll);
    EventBus.$off("getType", this.getType);
    //移除监听
    document.removeEventListener("click", this.monitoringClick.bind(this));
  },
  watch: {
    type: {
      handler(val) {
        if (val == "听说模拟训练") {
          this.progressHeadVisible = true;
        } else{
          this.progressHeadVisible = false;
        }
      },
      immediate: true,
    },
    coilingId: {
      handler(newVal, oldVal) {
        console.log("=======coilingId change======>", newVal, oldVal);
        this.coilingWatchId.newId = newVal
        this.coilingWatchId.oldId = oldVal
        this.resethData()
        // toplist与submitList交互 包括拉取当前试卷id数据保存submitList，将上次试卷id的数据保存到submitList
        // this.topSubmitOpt(newVal, oldVal); 四期将请求流程放到内容请求完成之后
      },
    },
    fieldsJSON: {
      handler(newVal, oldVal) {
        this.newVal = newVal;
        this.oldVal = oldVal;
        this.topSubmitOpt(this.coilingWatchId.newId, this.coilingWatchId.oldId);
        // this.$nextTick(()=>{
        //   // setTimeout(()=>{
        //     EventBus.$emit('updateProgressItem', { newVal, oldVal })
        //   // },1000)
        // })
      },
      deep: true,
      // immediate:true
    },
    // progressItems(newVal, oldVal){
    //   this.$nextTick(()=>{
				
		// 	})
    // }
  },
  data() {
    return {
      initIndex: parseInt(new Date().getTime() / 1000),
      labelArr: [],
      progressItemBasic: {
        //答题流程基础结构
        id: 1,
        name: "",
        time: "",
        audioUrl: "",
        audioDuration: "",
        audioName: "",
        audioFormat: "",
        playTimes: "1",
        displays: [],
        inputs: [],
        options: [],
        modeOptions: [],
        preStep: "",
        nextStep: "",
        bindId: "",
        display: "",
      },
      oldVal: {},
      newVal: {},
      topList: [], //顶部列表，每个试卷的数据结构
      submitList: [], //最终提交的数据结构，所有试卷的数据结构
      progressItems: [],
      processIndex: 0,
      progressItemIdx: -1,
      isOperate: false,
      isPractise: true,
      screenTop: 0, // 操作弹框top侧距离
      screenLeft: 0, // 操作弹框左侧距离
      fieldsArrActive: [], // 栏位中状态
      progressHeadVisible: false, // 流程头部是否显示
      optionNotEmpty: true,
      nowId: 0, // id
      type: "", // 模块类型: 听说模拟训练, 题型专项训练  todo
      nowLabel: "", //当前大题'一'，'二', '三'， '四' 听说模拟训练特有
      nowLabelId: "",
      ops: {
        vueScroll: {},
        scrollPanel: {
          speed: 300,
        },
        rail: {
          opacity: "0.1",
          border: "1rem solid #f2f2f2",
          size: "3rem",
        },
        bar: {
          size: "4rem",
          background: "#D9D9D9",
          keepShow: false,
        },
      },
      scroll: { x: 0, y: 0 },
      lastScroll: { x: 0, y: 0 },
      coilingWatchId:{
        newId:'',
        oldId:''
      }
    };
  },

  methods: {
    resethData(){
      this.progressItems = [];
      // this.submitList = [];  //todo   清空保存流程的参数数组
    },
    refreshModeSetting(flag) {
      switch(this.$store.state.pageNum){
        case "1":
          getModeSetting({
            regionId: this.regionId,
            bookId: this.bookId,
            catalogType: this.catalogType,
          }).then((res) => {
            if (res.data && res.data.testOperations) {
              let opts = JSON.parse(res.data.testOperations);
              if (opts.length > 0) {
                this.optionNotEmpty = true;
              } else {
                this.optionNotEmpty = false;
              }
              this.modeOptions = opts;
            } else {
              this.modeOptions = [];
              this.optionNotEmpty = false;
            }
            this.$forceUpdate();
            //对比_progressItems中数据
            if (flag) {
              this.$refs.progressItemRef.forEach((item) =>
                item.compareWithProgressOps()
              );
            }
          });
          break;
        case "2":
          getRefiningModeSetting({
            regionId: this.regionId,
            bookId: this.bookId,
            catalogId: this.catalogId,
          }).then((res) => {
            if (res.data && res.data.testOperations) {
              let opts = JSON.parse(res.data.testOperations);
              if (opts.length > 0) {
                this.optionNotEmpty = true;
              } else {
                this.optionNotEmpty = false;
              }
              this.modeOptions = opts;
            } else {
              this.modeOptions = [];
              this.optionNotEmpty = false;
            }
            this.$forceUpdate();
            //对比_progressItems中数据
            if (flag) {
              this.$refs.progressItemRef.forEach((item) =>
                item.compareWithProgressOps()
              );
            }
          });
          break;
      }
      // getModeSetting({
      //   regionId: this.regionId,
      //   bookId: this.bookId,
      //   catalogType: this.catalogType,
      // }).then((res) => {
      //   if (res.data && res.data.testOperations) {
      //     let opts = JSON.parse(res.data.testOperations);
      //     if (opts.length > 0) {
      //       this.optionNotEmpty = true;
      //     } else {
      //       this.optionNotEmpty = false;
      //     }
      //     this.modeOptions = opts;
      //   } else {
      //     this.modeOptions = [];
      //     this.optionNotEmpty = false;
      //   }
      //   this.$forceUpdate();
      //   //对比_progressItems中数据
      //   if (flag) {
      //     this.$refs.progressItemRef.forEach((item) =>
      //       item.compareWithProgressOps()
      //     );
      //   }
      // });
    },
    //联系、考试面试切换
    UpdatepractiseMode(boolean) {
      this.isPractise = boolean;
    },
    handleScroll() {
      this.scroll = {
        x: window.scrollX,
        y: window.scrollY,
      };
    },
    onScroll() {
      this.isOperate = false;
    },
    //create阶段拉取数据 根据试卷id拉取的数据传给toplist，赋值对应的progressItems
    //需要考虑数据的type和label
    // toplist与submitlist交互,
    async topSubmitOpt(newVal, oldVal) {
      this.$store.commit("updateProcessContent",'')
      // this.$store.commit("updateTestContent",'')

      if (this.$refs["progressHead"]) {
        this.$refs["progressHead"].resetItemIdx();
      }
      if (newVal == -1) {
        return;
      }
      //保存上一次试卷id的toplist数据，保存为json字符串
      let _topList = JSON.stringify(this.topList);
      let storageTopList = sessionStorage.getItem(newVal + "topList");
      let result;
      if (!storageTopList) {
        //根据试卷id拉取流程数据保存到submitList,当submitList中不存在试卷id时，
        //直接保存到submitList中
        //保存完需要给toplist赋值，在页面上回显当前试卷id的数据
        let res = await getTopListById({ coilingId: newVal });
        if (res.data) {
          result = res.data.topList;
          if (result === null || result === "[]" || result === "") {
            result = [];
          }
          // this.setTestProcess(res.data.topList,newVal,res.data);
          this.setTestProcess(res.data.topList)
          this.arrangeSubmitList(result, newVal, oldVal, _topList);

          sessionStorage.setItem(
            this.coilingId + "topList",
            JSON.stringify(this.topList)
          );
        }
      } else {
        result = storageTopList;
        if (result === null || result === "[]" || result === "") {
          result = [];
        }
        // this.setTestProcess(result,newVal,'')
        this.setTestProcess(result)
        this.arrangeSubmitList(result, newVal, oldVal, _topList);
      }
      EventBus.$emit("getProgressCollectionStatus", newVal); //notodo
      // EventBus.$emit('updateProgressItem', { newVal, oldVal })  //接口请求结束调用显示已失效的函数
      
      // EventBus.$emit('addSaveBtnLock', newVal)  //给保存按钮解锁
      this.$nextTick(()=>{
        // setTimeout(()=>{
          EventBus.$emit('updateProgressItem', { 'newVal':this.newVal, 'oldVal':this.oldVal })
        // },1000)
      })
    },
    setTestProcess(result){ //将流程存到vuex中
      // console.log('&&',JSON.stringify(result),result)
      if (result !== null && result !== "[]" && result !== "" && result.length > 0) {
          this.$store.commit("updateProcessContent",JSON.parse(result))
      }
      // let storageProcess = sessionStorage.getItem(id + "");
      // if (storageProcess !== null && storageProcess !== "[]" && storageProcess !== "") {
      //     this.$store.commit("updateTestContent",storageProcess)
      // }else{
      //   this.$store.commit("updateTestContent",data.content)
      // }
      // EventBus.$emit("getCollectionStatus", this.coilingId);
      // EventBus.$emit("getProgressCollectionStatus", id);
    },
    arrangeSubmitList(result, newVal, oldVal, _topList) {
      if (this.submitList.length == 0) {
        this.submitList.push({ id: newVal, topList: result });
      } else {
        let flag = false;
        this.submitList.forEach((item) => {
          if (item.id == newVal) {
            flag = true;
            item.topList = result;
          }
        });
        if (!flag) {
          this.submitList.push({ id: newVal, topList: result });
        }
      }
      //赋值给toplist回显

      _.cloneDeep(this.submitList).forEach((item) => {
        if (item.id == newVal) {
          if (typeof item.topList == "string") {
            this.topList = JSON.parse(item.topList);
          } else {
            this.topList = item.topList;
          }
        }
      });

      //将上次试卷id的toplist保存至submitList中
      this.saveTopListToSubmitList(oldVal, _topList, result);
    },

    saveTopListToSubmitList(oldVal, _topList, result) {
      if (oldVal != -1) {
        this.submitList.forEach((item) => {
          if (item.id == oldVal) {
            item.topList = _topList;
          }
        });
      }
      //切换页面置空progressItems，重要！
      if (this.type == "题型专项训练") {
        this.progressItemIdx = -1;
      }
      if (this.type == "听说模拟训练") {
        this.nowLabel = "";
        this.progressItems = [];
      } else {
        this.progressItemIdx = -1;
        let _result;
        if (typeof result == "string") {
          _result = JSON.parse(result);
        } else {
          _result = result;
        }
        if (_result.length > 0) {
          this.progressItems = _result[0].progressItems;
        } else {
          this.progressItems = [];
        }
      }
    },

    //保存submitList数据, submitList数据更新时间点: 1.当切换试卷id时候; 2.点击保存按钮的时候
    saveProgress() {
      //删除失效的图标
      this.delFailedQuestionNumber();
      console.log(JSON.stringify(this.topList));

      let cacheData = JSON.parse(sessionStorage.getItem(this.coilingId+'topList'));
      if(cacheData){  //四期解决获取不到插入流程的问题 notodo
        this.topList = cacheData;
      }
      // this.topList = JSON.parse(sessionStorage.getItem(this.coilingId+'topList'));  //四期解决获取不到插入流程的问题 notodo


      console.log(this.topList,this.coilingId+'topList');

      if (this.topList.length > 0) {
        this.submitList.forEach((item) => {
          if (item.id == this.coilingId) {
            item.topList = this.topList;
          }
        });
      }

      if (this.submitList.length > 0) {
        let modeArr = [];
        this.submitList.forEach((item) => {
          //格式化submitListz中的toplist数据
          // if (typeof item.topList != "string") {
          //   item.topList = JSON.stringify(item.topList);
          // }
          let processItem = sessionStorage.getItem(item.id + "topList");
            // item.topList = JSON.stringify(item.topList);
          item.topList = processItem
          if(item.id == this.$store.state.coilingId){
            item = this.deelOperateData(item)
            modeArr.push(item);
          }
        });
        let fetchAPI =saveProgressBatch
        if(this.$store.state.pageNum==2){
          fetchAPI=saveProgressBatch4
        }
        fetchAPI(modeArr).then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功!");
            sessionStorage.setItem(
              this.coilingId + "topList",
              JSON.stringify(this.topList)
            );
          } else {
            this.$message.error("保存失败！" + res.info);
          }
        });
        console.log("🐞 - processBodyFour.vue:574 - saveProgressBatch :", this)
      }
    },
    deelOperateData(value){
      try{
        if(value){
          let modeData = JSON.parse(value.topList)
          modeData.some((item)=>{
            console.log(item)
            if(item.progressItems){
              item.progressItems.some((item2)=>{
                console.log(item2)
                item2.options = item2.options.filter((data)=>{return this.modeOptions.indexOf(data)!=-1})
              })
            }
          })
          value.topList = JSON.stringify(modeData)
          this.topList = modeData;
          return value
        }
      }catch(error){
        return value
      }
    },

    //获取所有一级标题，初始化顶部列表数据  todo
    getQuestionNumber(val) {
      this.$forceUpdate()
      this.$nextTick(() => {
        let lastLabelArr = JSON.parse(JSON.stringify(this.labelArr));
        let lastLength = lastLabelArr.length;
        let _labelArr = [];
        val.forEach((item) => {
          _labelArr.push({ id: item.divId, label: item.label });
        });
        this.labelArr = _labelArr;
        let _topList = _.cloneDeep(this.topList);
        //初始所有一级标题数据
        if (this.type == "听说模拟训练") {
          this.labelArr.forEach((la) => {
            let flag = false;
            _topList.forEach((i) => {
              if (i.id == la.id) {
                flag = true;
              }
            });
            //console.log('flag',flag)
            if (!flag) {
              this.topList.push({
                label: la.label,
                id: la.id,
                coilingId: this.coilingId, //试卷id
                type: this.type, //听说模拟训练,题型专项训练
                progressItems: [],
              });
            }
          });
          sessionStorage.setItem(this.coilingId + 'progress', JSON.stringify(this.topList))
          // sessionStorage.setItem(this.coilingId + 'topList', JSON.stringify(this.topList))
        }
        //比对一级题干，当某一级题干被删除时，删除当前一级题干下面的所有数据
        if (lastLength > this.labelArr.length) {
          //当最后一个一级题干被删除时
          if (lastLength == 1 && this.labelArr.length == 0) {
            this.topList.forEach((item, index) => {
              if (item.id == lastLabelArr[0].id) {
                //当前页面的数据清空
                if (item.id == this.nowLabelId) {
                  this.progressItems = [];
                }
                this.topList.splice(index, 1);
              }
            });
          } else {
            let ids = Array.from(lastLabelArr, ({ id }) => id);
            let newIds = Array.from(this.labelArr, ({ id }) => id);
            console.log("newIds", newIds);
            ids.forEach((id) => {
              if (newIds.indexOf(id) == -1) {
                //删除progressItem
                this.topList.forEach((i, index) => {
                  if (i.id == id) {
                    if (id == this.nowLabelId) {
                      this.progressItems = [];
                    }
                    this.topList.splice(index, 1);
                  }
                });
              }
            });
          }
          //一级标题删除后重置nowLabelId
          if (this.labelArr.length != 0) {
            this.nowLabelId = this.labelArr[0].id;
            this.topList.forEach((item) => {
              if (item.id == this.nowLabelId) {
                this.progressItems = item.progressItems;
              }
            });
          }
        }
      });
    },

    delFailedQuestionNumber() {
      const arr = _.map(this.labelArr, "id");
      const _result = _.filter(this.topList, function (item) {
        return arr.indexOf(item.id) > -1;
      });
      this.topList = _result;
    },
    //获取试题模块类型
    getType(val) {
      this.type = val;
    },
    //获取当前一级标题
    //此处需要将当前toplist中对应的progressItems赋值给页面中的progressItems
    //如果对应的progressItems不存在先创建
    getNowLabel(labelItem) {
      this.nowLabel = labelItem.label;
      this.nowLabelId = labelItem.id;
      this.progressItemIdx = -1;
      if (this.type == "听说模拟训练") {
        let hasLabel = false;
        this.topList.forEach((item) => {
          if (item.id == labelItem.id) {
            hasLabel = true;
          }
        });
        if (!hasLabel) {
          this.topList.push({
            label: labelItem.label,
            id: labelItem.id,
            coilingId: this.coilingId, //试卷id
            type: this.type, //听说模拟训练,题型专项训练
            progressItems: [],
          });
        }
        //赋值progressItems
        this.topList.forEach((item, index) => {
          if (item.id == labelItem.id) {
            this.processIndex = index;
            this.progressItems = item.progressItems;
          }
        });
      }
      //听说模拟训练 大题按钮切换时，没有删除的失效样式仍要保留
      this.$nextTick(() => {
        if (this.$refs.progressItemRef) {
          this.$refs.progressItemRef[0]?.updateProgressItem({
            newVal: this.newVal,
            oldVal: this.oldVal,
          });
        }
      });
    },

    //新建流程
    createProgressItem() {
      this.initIndex++;
      let _progressItemBasic = JSON.parse(
        JSON.stringify(this.progressItemBasic)
      );
      _progressItemBasic.id = this.initIndex;console.log(this.labelArr,this.type);
      //如果是题型专项训topLis为空练在此处就要创建结构，它没有label框
      // const types = ['听后回答','听后选择', '听后转述','短文朗读','新考点', '新形势', '新题型']
      // if ((this.type != "听说模拟训练" ||  types.includes(this.type))&& this.topList.length == 0) {
      if (this.topList.length == 0) {
        if (this.labelArr.length == 0) {
          this.$message.error(
            "请先创建试题内容的一级题干或点击答题流程的题干！"
          );
          return;
        }
        this.progressItems.push(_progressItemBasic);
        this.topList.push({
          label: "",
          id: this.labelArr[0].id,
          coilingId: this.coilingId, //试卷id
          type: this.type, //听说模拟训练,题型专项训练
          progressItems: this.progressItems,
        });
        //赋值progressItems
        this.progressItems = this.topList[0].progressItems;
      } else {
        //听说模拟训练需要判断是否能创建流程, 题型专项训练不需要判断  todo
        // if (
        //   (this.type == "听说模拟训练" && this.nowLabel) ||
        //   (this.type == "题型专项训练" && this.labelArr.length > 0) ||
        //   (types.includes(this.type) && this.labelArr.length > 0)
        // ) 
        if(this.labelArr.length > 0)
        {
          this.progressItems.push(_progressItemBasic);
          this.updateTopList();
        } else {
          //题型专项训练的流程必须先要创建一级标题的试题内容，
          this.$message.error(
            "请先创建试题内容的一级题干或点击答题流程的题干！"
          );
        }
      }
      sessionStorage.setItem(
        this.coilingId + "topList",
        JSON.stringify(this.topList)
      );
    },
    createProgressFromCollection() {
      if (this.topList.length == 0) {
        console.log("开始从头部开始加入流程的收藏");
        EventBus.$emit("scjShow", {
          n1: true,
          n2: false,
          nowId: 0,
          direction: false,
          from: "progress",
        });
        /* this.topList.push({
          label: '',
          id: this.labelArr[0].id,
          coilingId: this.coilingId, //试卷id
          type: this.type, //听说模拟训练,题型专项训练
          progressItems: [],
        });
        //赋值progressItems
        this.progressItems = this.topList[0].progressItems */
      } else {
        //听说模拟训练需要判断是否能创建流程, 题型专项训练不需要判断  todo
        // if (
        //   (this.type == "听说模拟训练" && this.nowLabel) ||
        //   (this.type == "题型专项训练" && this.labelArr.length > 0)
        // )
        if (this.labelArr.length > 0) 
        {
          /* this.progressItems.push(_progressItemBasic);
          this.updateTopList(); */ console.log(
            "开始从头部开始加入流程的收藏22222"
          );
          EventBus.$emit("scjShow", {
            n1: true,
            n2: false,
            nowId: 0,
            direction: false,
            from: "progress",
          });
          //EventBus.$emit("createProgress");
        } else {
          //题型专项训练的流程必须先要创建一级标题的试题内容，
          this.$message.error(
            "请先创建试题内容的一级题干或点击答题流程的题干！"
          );
        }
      }
      sessionStorage.setItem(
        this.coilingId + "topList",
        JSON.stringify(this.topList)
      );
    },
    showTopicData(){
      let vuexData = this.$store.state;
      let json = {
        'coilingId':vuexData.coilingId,
        'type':vuexData.catalogType,
        'progressItems': this.progressItems,
        'id': parseInt(new Date().getTime() / 1000)+'',
        'label': ""
      }
      sessionStorage.setItem(vuexData.coilingId + "topList",JSON.stringify([json]));
      this.topList = [json]
      // if(this.topList){
      //   if(this.topList.length){
      //     sessionStorage.setItem(
      //       this.coilingId + "topList",
      //       JSON.stringify(this.topList)
      //     );
      //   }else{
      //     let json = {
      //       'coilingId':vuexData.coilingId,
      //       'type':vuexData.catalogType,
      //       'progressItems': this.progressItems,
      //       'id': parseInt(new Date().getTime() / 1000)+'',
      //       'label': ""
      //     }
      //     sessionStorage.setItem(vuexData.coilingId + "topList",JSON.stringify([json]));
      //     this.topList.push(json)
      //   }
      // }else{
      //   let json = {
      //     'coilingId':vuexData.coilingId,
      //     'type':vuexData.catalogType,
      //     'progressItems': this.progressItems,
      //     'id': parseInt(new Date().getTime() / 1000)+'',
      //     'label': ""
      //   }
      //   sessionStorage.setItem(vuexData.coilingId + "topList",JSON.stringify([json]));
      //   this.topList.push(json)
      // }
    },
    //插入收藏
    operateInsertProgressCollection(direction, id, fieldStr) {
      console.log("插入前fieldStr：", fieldStr);
      this.initIndex++;
      //console.log("initIndex====", this.initIndex)
      let fieldItem = JSON.parse(JSON.stringify(fieldStr));
      fieldItem.id = this.initIndex;
      //fieldStr.id = this.initIndex;
      console.log("改变id的fieldItem：", fieldItem,id);
      let isSucces = true;
      if (id === 0) {
        this.progressItems.splice(this.progressItems.length, 0, fieldItem);
        this.changeNowId();
        this.updateTopList();

        // this.$nextTick(()=>{
        //   EventBus.$emit('updateProgressItem',{'newVal':this.$store.state.fieldsJSON})
        // })
      } else {
        //插入
        isSucces = this.progressItems.some((item, index) => {
          if (item.id === id) {
            console.log("找到之后index===", index);
            if (direction) {
              //向上
              this.progressItems.splice(index, 0, fieldItem);
              this.progressItemIdx = this.progressItemIdx + 1;
            } else {
              //向下
              this.progressItems.splice(index + 1, 0, fieldItem);
            }
            this.changeNowId();
            console.log("插入收藏topList====", this.topList);
            this.updateTopList();
            // this.$nextTick(()=>{
            //   EventBus.$emit('updateProgressItem',{'newVal':this.$store.state.fieldsJSON})
            // })
            return true;
          }
        });
      }
      console.log(isSucces);
      /* if (isSucces) {
        this.$message({
          message: "添加流程成功！",
          type: "success",
        });
      } else {
        this.$message({
          message: "添加流程失败！",
          type: "error",
        });
      } */
    },
    updateProgressToPage(newProgress, type) {
      console.log("this.nowLabelId===", this.nowLabelId);
      if ("听说模拟训练" !== type) {
        if (!this.nowLabelId) {
          this.nowLabelId = newProgress[0].id;
        }
        this.progressItems = newProgress[0].progressItems;
      } else {
        newProgress.forEach((progress, index) => {
          if (progress.id === this.nowLabelId) {
            console.log("这是第" + index + "个label");
            this.progressItems = progress.progressItems;
            return;
          }
        });
      }
      //this.nowLabelId = this.nowLabelId ? this.nowLabelId : newProgress[0].id

      this.topList = newProgress;
      this.updateTopList();
    },

    //插入流程
    operateInsertBlank(direction, id) {
      this.initIndex++;
      let _progressItemBasic = JSON.parse(
        JSON.stringify(this.progressItemBasic)
      );
      _progressItemBasic.id = this.initIndex;
      //插入
      let isSucces = this.progressItems.some((item, index) => {
        if (item.id === id) {
          if (direction) {
            //向上
            this.progressItems.splice(index, 0, _progressItemBasic);
            this.progressItemIdx = this.progressItemIdx + 1;
          } else {
            //向下
            this.progressItems.splice(index + 1, 0, _progressItemBasic);
          }
          this.changeNowId();
          this.updateTopList();
          return true;
        }
      });
      if (isSucces) {
        this.$message({
          message: "添加流程成功！",
          type: "success",
        });
      } else {
        this.$message({
          message: "添加流程失败！",
          type: "error",
        });
      }
    },

    changeNowId() {
      if (this.progressItems[this.progressItemIdx]) {
        this.nowId = this.progressItems[this.progressItemIdx].id;
      }
    },

    //删除流程
    operateDelete(id) {
      let isSucces = this.progressItems.some((item, index) => {
        if (item.id == id) {
          this.progressItems.splice(index, 1);
          this.changeNowId();
          this.updateTopList();
          return true;
        }
      });
      if (isSucces) {
        this.$message.success("删除流程成功！");
      } else {
        this.$message.error("删除流程失败！");
      }
    },

    //复制流程
    operateCopy(id) {
      let isSucces = this.progressItems.some((item, index) => {
        this.initIndex++;
        if (item.id == id) {
          let copyItem = JSON.parse(JSON.stringify(item));
          copyItem.id = this.initIndex;
          this.progressItems.splice(index + 1, 0, copyItem);
          console.log("复制流程复制流程复制流程复制流程", this.progressItems);
          this.changeNowId();
          this.updateTopList();
          return true;
        }
      });
      if (isSucces) {
        this.$message({
          message: "复制流程成功！",
          type: "success",
        });
      } else {
        this.$message({
          message: "复制流程失败！",
          type: "error",
        });
      }
    },

    //流程操作后 需要更新top列表数据  todo
    updateTopList() {
      this.topList.forEach((item) => {
        if (this.type == "听说模拟训练") {
          if (item.id === this.nowLabelId) {
            item.progressItems = JSON.parse(JSON.stringify(this.progressItems));
          }
        } else {
          //题型专项训练的updateTopList只有一个对象直接更新
          item.progressItems = JSON.parse(JSON.stringify(this.progressItems));
        }
      });
      sessionStorage.setItem(
        this.coilingId + "topList",
        JSON.stringify(this.topList)
      );
      // console.log(
      //   "updateTopList.progressItems ==>",
      //   this.topList[0].progressItems
      // );
    },

    //获取答题流程焦点
    progressItemSelected(index, id) {
      this.progressItemIdx = index;
      this.nowId = id;
    },

    //答题流程操作按钮点击
    handleOperate(e) {
      this.lastScroll = _.cloneDeep(this.scroll);
      let wHeight = window.innerHeight;
      this.isOperate = true;
      const rect = e.target.getBoundingClientRect();
      this.screenLeft = rect.left - 47;
      if (rect.top + 200 < wHeight) {
        this.screenTop = rect.top + window.scrollY + 26;
      } else {
        this.$nextTick(() => {
          let operateBoxH = this.$refs.operateBox.offsetHeight;

          this.screenTop = rect.top - operateBoxH - 6;
        });
      }
    },

    // 监听点击事件
    monitoringClick(e) {
      const target = e.target;
      const classList = target.classList;
      // // 转换为字符串输出
      const classes = Array.from(classList).join(" ");
      //判断点击元素是否是操作框
      if (classes != "handleFields") {
        this.isOperate = false;
      }
    },

    //拖拽
    initSortable() {
      new Sortable(this.$refs.sortableRef, {
        delay: 10,
        animation: 150,
        // 如果有不想排序的，在这里按照class匹配的方式写出即可
        filter: ".demo-title",
        // 需要拖拽的标签的class，强烈推荐写
        draggable: ".fieldsList",
        handle: ".fields_move",
        // drop placeholder的css类名
        ghostClass: "blue-background-class",
        onEnd: (evt) => {
          //重排progressItems数组
          this.resortProgressItems(evt);
        },
      });
    },
    //拖拽后排序
    resortProgressItems(evt) {
      let oldIndex = evt.oldIndex;
      let newIndex = evt.newIndex;
      const _progressItems = JSON.parse(JSON.stringify(this.progressItems));
      const item = _progressItems.splice(oldIndex, 1)[0];
      _progressItems.splice(newIndex, 0, item);
      this.progressItems = _progressItems;
      this.updateTopList();
    },
    //子组件调用更新顶级列表数据  听说模拟训练需要判断label，题型专项训练不需要
    updateTolist(progressItem) {
      console.log("updateTolist(progressItem) =======>", this.topList);
      this.topList.forEach((topItem) => {
        if (this.type == "听说模拟训练") {
          if (topItem.id == this.nowLabelId) {
            topItem.progressItems.forEach((proItem, idx) => {
              if (proItem.id === progressItem.id) {
                topItem.progressItems[idx] = progressItem;
              }
            });
          }
        } else{
          topItem.progressItems.forEach((proItem, idx) => {
            if (proItem.id === progressItem.id) {
              topItem.progressItems[idx] = progressItem;
            }
          });
        }
      });
      sessionStorage.setItem(
        this.coilingId + "topList",
        JSON.stringify(this.topList)
      );
      console.log("updateTolist====>", this.topList);
      EventBus.$emit("getProgressCollectionStatus", this.coilingId);
    },
    scjShow(data) {
      this.$emit("scjShow", data);
    },
  },
};
</script>
<style lang='scss' scoped>
.progress_container {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 6rem;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .progress_body {
    box-sizing: border-box;
    padding: 0rem 10rem 20rem 10rem;
    overflow: hidden;
    height: 100%;

    .progress_item {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      margin-right: 26rem;
      margin-left: 16rem;
    }

    .progress_item_selected {
      border: 2rem solid var(--primary-color);
    }

    .fields_move {
      position: absolute;
      width: 14rem;
      height: 100%;
      top: 0;
      cursor: grab;
      display: none;
      align-items: center;
      justify-content: center;
    }

    .fields_move_selected {
      display: flex;

      img {
        width: 6rem;
        height: 10rem;
      }
    }

    .fields_operation {
      position: absolute;
      width: 16rem;
      height: 100%;
      right: 8rem;
      top: 0;
      display: none;
    }

    .fields_operation_selected {
      display: flex;
      justify-content: center;
      flex-direction: column;

      .el-popper {
        width: 180rem;
      }
    }

    .fieldsList {
      display: flex;
      align-items: center;
      margin-bottom: 20rem;
      &.hide{
        margin-bottom: 0;
      }
    }
  }

  .operateBox {
    width: 112rem;
    position: fixed;
    z-index: 2;
    background: #fff;
    border: 1rem solid rgba(0, 0, 0, 0.15);
    border-radius: 4rem;
  }
}
</style>